/**
 * Helper function to pull the pageMeta from the event data and populate the needed fields.
 *
 * Expects eventData to have a property called `page_meta` that contains the meta information. If the `page_meta` object
 * doesn't contain a key called `page` it attempts to populate it from the other event data using either the `page` or
 * `path` event key.
 * @param eventData - The event data
 * @returns [{}, {}] - array of dictionaries where the first element is the page meta information and the second is
 *  the other event data.
 */
export function buildPageMeta(eventData) {
    const { page_meta:pageMeta={}, ...eventProperties } = eventData;

    // Add the path to the current page as the `page` key to the page metadata if it's missing.
    if (!Object.prototype.hasOwnProperty.call(pageMeta,'page')) {
        let pagePath;
        if (Object.prototype.hasOwnProperty.call(eventProperties, 'page')) {
            pagePath = eventProperties.page;
        } else if (Object.prototype.hasOwnProperty.call(eventProperties, 'path')) {
            pagePath = eventProperties.path;
        }

        // Only set the page if we found one
        if (pagePath) {
            pageMeta.page = pagePath;
        }
    }

    return [pageMeta, eventProperties];
}
